var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCabinLuggage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "56px",
    viewBox: "0 0 26 56",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "FE8D8F0F-611C-47D1-ABC8-28926C2F2121") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "KLM-Viewports",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "KLM-FE-1218",
    transform: "translate(-532, -598)",
    fill: "#00A1DE"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Transavia/NotAble/1440",
    transform: "translate(16, 169)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Small/Hand-luggage-Copy",
    transform: "translate(516.0917, 429)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.45,3.15 L15.75,3.15 L15.75,12.6 L18.9,12.6 L18.9,1.575 C18.9,0.7 18.2,0 17.325,0 L7.875,0 C7,0 6.3,0.7 6.3,1.575 L6.3,12.425 L9.45,12.425 L9.45,3.15 L9.45,3.15 Z M20.3,15.575 L4.725,15.575 C2.1,15.575 0,17.675 0,20.3 L0,44.975 C0,47.6 2.1,49.7 4.725,49.7 L20.3,49.7 C22.925,49.7 25.025,47.6 25.025,44.975 L25.025,20.3 C25.025,17.675 22.925,15.575 20.3,15.575 L20.3,15.575 Z M3.85,50.75 C5.25,50.75 6.475,51.975 6.475,53.375 C6.475,54.775 5.425,56 3.85,56 C2.275,56 1.225,54.775 1.225,53.375 C1.225,51.975 2.45,50.75 3.85,50.75 L3.85,50.75 Z M21.175,50.75 C22.575,50.75 23.8,51.975 23.8,53.375 C23.8,54.775 22.575,56 21.175,56 C19.775,56 18.55,54.775 18.55,53.375 C18.55,51.975 19.6,50.75 21.175,50.75 L21.175,50.75 Z",
    id: "Combined-Shape"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCabinLuggage);
export default __webpack_public_path__ + "static/media/cabin_luggage.17a3bbf44881a2ca924056ee7e4d28ba.svg";
export { ForwardRef as ReactComponent };